import { z } from 'zod';
import {
  QuizBankSchema,
  QuizAttemptStateSchema,
  PaginationMetaSchema,
  type QuizBank,
  type QuizAttemptState,
} from '@shared/schemas';
import { apiFetch, type ApiFetchOptions } from '../client';

const BankResponse = z.object({ bank: QuizBankSchema });
const AttemptStartResponse = z.object({
  attemptId: z.string(),
  attempt: QuizAttemptStateSchema,
});
const AttemptPatchResponse = z.object({
  attemptId: z.string(),
  attempt: QuizAttemptStateSchema,
});
const AttemptListItem = z.intersection(
  QuizAttemptStateSchema,
  z.object({ id: z.string() }),
);
const AttemptListResponse = z.object({
  data: z.array(AttemptListItem),
  pagination: PaginationMetaSchema,
});

export const quizEndpoints = {
  async getBank(id: string, opts: Pick<ApiFetchOptions, 'signal'> = {}): Promise<QuizBank> {
    const res = await apiFetch(BankResponse, `/api/quiz/banks/${encodeURIComponent(id)}`, {
      signal: opts.signal,
    });
    return res.bank;
  },

  async startAttempt(
    bankId: string,
    opts: Pick<ApiFetchOptions, 'signal'> = {},
  ): Promise<{ attemptId: string; attempt: QuizAttemptState }> {
    return apiFetch(AttemptStartResponse, '/api/quiz/attempt', {
      method: 'POST',
      body: { bankId },
      signal: opts.signal,
    });
  },

  async patchAttempt(
    attemptId: string,
    body: Partial<QuizAttemptState>,
    opts: Pick<ApiFetchOptions, 'signal'> = {},
  ): Promise<{ attemptId: string; attempt: QuizAttemptState }> {
    return apiFetch(AttemptPatchResponse, `/api/quiz/attempt/${encodeURIComponent(attemptId)}`, {
      method: 'PATCH',
      body,
      signal: opts.signal,
    });
  },

  async listAttempts(
    page = 1,
    size = 20,
    opts: Pick<ApiFetchOptions, 'signal'> = {},
  ): Promise<{
    data: Array<QuizAttemptState & { id: string }>;
    pagination: { page: number; size: number; total: number };
  }> {
    return apiFetch(AttemptListResponse, '/api/quiz/attempts', {
      query: { page, size },
      signal: opts.signal,
    });
  },
};
